import { render, staticRenderFns } from "./TicketsChatMessages.vue?vue&type=template&id=5b01b172&scoped=true&"
import script from "./TicketsChatMessages.vue?vue&type=script&lang=js&"
export * from "./TicketsChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./TicketsChatMessages.vue?vue&type=style&index=0&id=5b01b172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01b172",
  null
  
)

export default component.exports